// extracted by mini-css-extract-plugin
export default {"page":"l4-z","cartModal":"m4-z","checkout":"n4-z","placeholder":"o4-z","account":"p4-z"};